module.exports = __webpack_public_path__ + "static/media/ordem-rosacruz-amorc-branco.d8a98d99.png";